import Navbar from "../components/Navbar/Navbar";
import Hero from "../components/Main/Presentation/SearchFlight";
import Footer from "../components/Footer/Footer";
import React from "react";
import "../components/Main/Presentation/SearchFlight.css";
import { useRecoilValue } from 'recoil';
import { protectionState } from '../events/recoils';
import BookingConfirmationEmail from "../widget/bookingConfirmationEmail";

const Thanks = () => {
    const refundState = useRecoilValue(protectionState);

    return (
        <div className="thanks-page">
            <Navbar />
            <Hero
                cName="hero-mid"
                heroImg="https://images.unsplash.com/photo-1454942901704-3c44c11b2ad1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
                title="THANKS FOR YOUR PURCHASE!"
                text={refundState.protectionSelected && "YOUR PURCHASE IS PROTECTED"}
            />

            {refundState.protectionSelected && <BookingConfirmationEmail/>}

            <Footer />
        </div>
    );
};

export default Thanks;